import { Tab, TabProps } from '@mui/material';
import React from 'react';

const TabWrapper: React.FC<TabProps> = ({ ...props }) => <Tab {...props} />;

export default TabWrapper;
